interface JWTPayload {
  exp?: number; // expiration in seconds since epoch
  [key: string]: any;
}

export function isTokenValid(): boolean {
  const token = localStorage.getItem("jwt");
  if (!token) return false;

  try {
    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64);
    const payload: JWTPayload = JSON.parse(payloadJson);

    if (payload.exp) {
      const now = Math.floor(Date.now() / 1000);
      return payload.exp > now;
    }

    // if no exp claim, assume valid
    return true;
  } catch (err) {
    console.error("Invalid token", err);
    return false;
  }
}
